export class ActivityCostType{
 id: number;
  name: string;
}
